import React, { useState } from 'react';
import { Collapse } from 'reactstrap';

function ViewMyExtracurr(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    return (
    <div className="mg-t-20" >
        <div className="card" >
            <div className="card-header">
                <div className="card-header-left">
                    <h5>Extracurriculars</h5>
                </div>
                <div className="card-header-right">
                    <ul className="row" >                        
                         
                        <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                        
                    </ul>
                </div>
            </div>
            <Collapse isOpen={!collapse}>            
            <hr className="mg-l-20" ></hr>
            <div className="card-block">
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Swimming</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15 mg-b-10">
                        <div>National Swimmer, 1988
                            <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                            <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                            <i className="fas fa-photo-video text-c-warning mg-l-10 c-pointer"></i>
                        </div>
                        <div>National Swimming Club, Calcutta, India</div>
                    </div>
                    <div className="mg-l-15">
                        <div>3rd in State Swimming Championship, 1990
                            <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                        </div>
                        <div>West Bengal, India</div>
                    </div>
                    </div>
                </div>                
                <hr className="mg-r-0" ></hr> 
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20 " >
                        <div className="card-list-header">Watching Movies</div>
                    </div>                    
                </div>  
                <hr className="mg-r-0" ></hr>  
                <div className="v-align mg-b-15">
                    <div className="wd-pct-20" >
                        <div className="card-list-header">Art</div>
                    </div>
                    <div className="b-l-border">
                    <div className="mg-l-15 ">
                        <div>2nd in State Art Competition
                            <i className="fas fa-certificate text-c-success mg-l-10 c-pointer"></i>
                        </div>
                        <div>Nehru Indoor Stadium, Calcutta, India</div>
                    </div>
                    </div>
                </div>         
            </div>
            </Collapse>
    </div>
    </div>
        
    );
  }

export default ViewMyExtracurr